<template>
<v-tabs v-model='activeTab' >
  <v-tab >{{ $t('tabs.one') }}</v-tab>
  <v-tab >{{ $t('tabs.two') }}</v-tab>
  <v-tabs-items v-model='activeTab' >
    <v-tab-item >
      <v-card flat>
        <v-toolbar dense flat >
          <v-btn
            :loading='invoicesRequest.loading'
            @click='getInvoices' small icon><v-icon small >replay</v-icon></v-btn>
          <v-toolbar-title class='subheading hidden-xs-only' >
            Invoices
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            @click='showCreateStatement = true' flat text small
            :disabled='!(selectedInvoices) || selectedInvoices.length === 0' >
            <v-icon small class='mr-1' >add</v-icon>
            {{ $t('buttons.createstatement') }}
          </v-btn>
          <!-- <v-btn icon >
            <v-icon>filter_list</v-icon>
          </v-btn> -->
          <v-btn
            @click="launchInvoiceDialog({relationshipId})" small color='primary' >
            <v-icon small class='mr-1' >add</v-icon>Invoice</v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <v-list three-line subheader>
            <vuex-loader :request-id='reqId' ></vuex-loader>

            <v-dialog v-model='showCreateStatement' :fullscreen='$vuetify.breakpoint.mdAndDown' :width='800' >
              <v-card flat >
                <v-toolbar dense flat dark :color='themeColor' >
                  <v-toolbar-title >
                    {{ $t('dialogs.titles.statement') }}
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn icon small
                    @click='showCreateStatement = false' ><v-icon>close</v-icon></v-btn>
                </v-toolbar>
                <statement
                  @close='showCreateStatement=false'
                  :touch='statementToucher'
                  :relationship-id='relationshipId'
                  v-if='selectedInvoices && selectedInvoices.length > 0'
                  :invoices='selectedInvoices' >
                </statement>
              </v-card>
            </v-dialog>

            <!-- @selected='gotoInvoice' -->
            <invoice-list
              class='invoice-list'
              @selected='setSelected'
              :invoices='pagedInvoices'
              :selected-invoice-ids='selectedInvoiceIds'
              :actions="invoiceActions"
              :withStatus='true'
              :loading="invoicesRequest.loading"
              v-on='invoiceEvents' >
            </invoice-list>
          <v-list-tile v-if='invoicesRequest.status === 200 && invoices.length === 0' >
            <v-list-tile-content>
              No invoices found
            </v-list-tile-content>
          </v-list-tile>

          <v-subheader v-else >Showing {{ Math.min(itemsToShow, invoices.length) }} of {{invoices.length}} Invoices</v-subheader>

          <v-list-tile>
            <v-btn v-show='hasMore' @click='itemsToShow+=pageSize' block flat>Load more</v-btn>
          </v-list-tile>

        </v-list>
      </v-card>

    </v-tab-item>
    <v-tab-item >
      <statement-list
        :touch='statementListToucher'
        :relationship-id='relationshipId' ></statement-list>
    </v-tab-item>
  </v-tabs-items>
</v-tabs>

</template>

<script>
import Statement from '@/components/forms/Statement'
import InvoiceList from '@/components/invoice/InvoiceList'
import StatementList from '@/components/lists/StatementList'
import InvoiceMixin from '@/mixins/invoice'

import {
  DELETE_INVOICE_REQ
} from '@/store/constants'

export default {
  name: 'ClientInvoices',
  mixins: [InvoiceMixin],
  props: {
    relationshipId: {default: null},
    clientId: {default: null},
    touch: { type: Number, default: 1 },
    pageSize: { type: Number, default: 10 }
  },
  components: {InvoiceList, Statement, StatementList},
  data () {
    return {
      activeTab: 0,
      statementToucher: 0,
      statementListToucher: 0,
      resource: 'invoices',
      reqId: 'get-invcoices-client',
      itemsToShow: 10,
      selectedInvoices: [],
      showCreateStatement: false
    }
  },
  mounted () {
    this.getInvoices()
    this.itemsToShow = this.pageSize
  },
  methods: {
    getInvoices () {
      if (this.clientId && this.me.id) {
        let params = {
          // practitioner_id: this.me.id,
          // customer_id: this.clientId,
          relationship_id: this.relationshipId,
          facets: 'practitioner_id,space_id'
        }
        this.$invoiceguru
          .resource(this.resource)
          .id(this.reqId)
          .list(params)
      }
    },
    invoiceUrl (invoice) {
      return `/invoices/${invoice.id}`
    },
    gotoInvoice (invoice) {
      this.$router.push({path: this.invoiceUrl(invoice)})
    },
    setSelected (invoice) {
      let index = this.selectedInvoices.findIndex((i) => {
        return i.id === invoice.id
      })
      if (index === -1) {
        this.selectedInvoices.push(invoice)
      } else {
        this.selectedInvoices.splice(index, 1)
      }
    }
  },
  computed: {
    me () { return this.$store.getters.me },
    hasMore () {
      return this.invoices.length >= this.itemsToShow
    },
    watchString () {
      return this.globalInvoiceQuickCreate.touch + this.globalCreateInvoice.touch + this.globalAppointmentAction.touch
    },
    globalInvoiceQuickCreate () {
      return this.$store.getters.getGlobalDialogEvent('InvoiceQuickCreate')
    },
    globalCreateInvoice () {
      return this.$store.getters.getGlobalDialogEvent('CreateInvoice')
    },
    globalAppointmentAction () {
      return this.$store.getters.getGlobalDialogEvent('AppointmentAction')
    },
    invoicesRequest () {
      return this.$store.getters.getRequestById(this.reqId, true)
    },
    deleteInvoiceRequest () {
      return this.$store.getters.getRequestById(DELETE_INVOICE_REQ, true)
    },
    deleteInvoiceRequestStatus () {
      return this.deleteInvoiceRequest.status
    },
    invoices () {
      return this.getObjectPath(this.invoicesRequest, 'result.data.results', [])
    },
    selectedInvoiceIds () {
      return this.selectedInvoices.map((inv) => {
        return inv.id
      })
    },
    pagedInvoices () {
      return this.invoices.slice(0, this.itemsToShow)
    }
  },
  watch: {
    activeTab () {
      if (this.activeTab === 1) {
        this.statementListToucher++
      }
    },
    clientId () {
      this.selectedInvoices = []
      this.getInvoices()
    },
    showCreateStatement () {
      this.statementToucher++
    },
    touch () {
      this.getInvoices()
    },
    deleteInvoiceRequestStatus () {
      if (this.deleteInvoiceRequestStatus === 204) {
        this.getInvoices()
      }
    },
    watchString () {
      this.getInvoices()
    }
  },
  i18n: {
    messages: {
      en: {
        tabs: {
          one: 'Invoices',
          two: 'Statements'
        },
        dialogs: {
          titles: {
            statement: 'Create a statement'
          }
        },
        buttons: {
          createstatement: 'Statement'
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// ClientInvoices.vue?266aa234